import _ from 'lodash'
import { List, fromJS } from 'immutable'
import { processKeys } from './CardComponent'

export const setInitialProjectUIState = (state) => {
  const uiState = {}
  _.each(processKeys, (key) => {
    uiState[key] = uiState[key] || {}
    const menu = state.getIn(['project', 'Settings', key, 'Menu'], List())
    menu.map((entry) => {
      if (!entry.get('show', true)) {
        uiState[key][entry.get('id')] = ['hide']
      }
      if (entry.get('isFolder', false)) {
        entry.get('children', List()).map((link) => {
          if (!link.get('show', true)) {
            uiState[key][link.get('id')] = ['hide']
          }
        })
      }
    })
  })
  return state.setIn(['rules', 'ui'], fromJS(uiState))
}
